import React, { PureComponent } from 'react'
import { withStyles } from '@material-ui/core/styles'
import BottomNavigation from '@material-ui/core/BottomNavigation'
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction'
import HappyIcon from '@material-ui/icons/Mood'
import NeutralIcon from '@material-ui/icons/SentimentNeutral'
import SadIcon from '@material-ui/icons/MoodBad'
import Tooltip from '@material-ui/core/Tooltip'
import { RED, YELLOW, GREEN } from '../config/colors'

const styles = {
  root: {
    width: 500
  }
}

const moods = ['good', 'moderate', 'poor']

class MoodChart extends PureComponent {
  state = {
    value: null
  }

  handleChange = (event, value) => {
    const { data, handleSelect, handleDeselect } = this.props
    // const key = event.target.getAttribute('value')
    const key = moods[value]
    const nextValue = this.state.value === value ? null : value

    if (nextValue !== null) {
      handleSelect(data[key] || [])
    } else {
      handleDeselect(data[key] || [])
    }
    this.setState({ value: nextValue })
  }

  handleClick = event => {
    const { handleClick } = this.props
    handleClick(event)
  }

  render () {
    const { data } = this.props

    return (
      <BottomNavigation
        showLabels
        onChange={this.handleChange}
        value={this.state.value}
      >
        <BottomNavigationAction
          style={{ color: GREEN }}
          label={data.good ? data.good.length : 0}
          icon={
            <Tooltip
              placement='top'
              id='tooltip-good'
              title={`${data.good ? data.good.length : 0} rated good`}
            >
              <HappyIcon value='good' />
            </Tooltip>
          }
          disableRipple
        />

        <BottomNavigationAction
          style={{ color: YELLOW }}
          label={data.moderate ? data.moderate.length : 0}
          icon={
            <Tooltip
              placement='top'
              id='tooltip-moderate'
              title={`${
                data.moderate ? data.moderate.length : 0
              } rated moderate`}
            >
              <NeutralIcon value='moderate' />
            </Tooltip>
          }
          disableRipple
        />
        <BottomNavigationAction
          style={{ color: RED }}
          label={data.poor ? data.poor.length : 0}
          icon={
            <Tooltip
              placement='top'
              id='tooltip-poor'
              title={`${data.poor ? data.poor.length : 0} rated poor`}
            >
              <SadIcon value='poor' />
            </Tooltip>
          }
          disableRipple
        />
      </BottomNavigation>
    )
  }
}

export default withStyles(styles)(MoodChart)



// WEBPACK FOOTER //
// ./src/charts/MoodChart.js